import React, { Component } from 'react'
import '../styles/Membership.css'
import DropdownWidget from '../widgets/DropdownWidget'
import deleteIcon from '../images/trash_green.png'
import addIcon from '../images/plus_green.png'
import deleteIconGray from '../images/trash_gray.png'
import addIconGray from '../images/plus_gray.png'
import APIGenericRequest from '../api/APIGenericRequest'
import APIFarmerRequest from '../api/APIFarmerRequest'
import APIOrganizationRequest from '../api/APIOrganizationRequest'
import APISiteRequest from '../api/APISiteRequest'
import AlertMessage from '../widgets/AlertMessage'

class Membership extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			listItems: [],
			itemObj: {},
			keyTracer: 0,
			orgList: {},
			deleteOrgList: {},
			upAddOrgList: {},
			addOrgList: {},
			addNewOrgList: {}
		}
		this.eventHandler = this.eventHandler.bind(this)
		this.getFarmerInfo = this.getFarmerInfo.bind(this)
		this.setAllFieldsDisabled = this.setAllFieldsDisabled.bind(this)
		this.getAllARBOCategories = this.getAllARBOCategories.bind(this)
	}

	setAllFieldsDisabled(v) {
		const fields = document.querySelectorAll('.membership-row *')
		for(const f of fields) {
			f.disabled = v
		}
	}

	getFarmerInfo() {
		const farmer = APIFarmerRequest.getFarmerDetailsById(this.state.accessToken, parseInt(this.props.farmerID))
		farmer.then((response) => {
			if(this.props.view === "update") {
				this.getAllARBOCategories(response.results.organizationMembership)
				return
			}
			const added = []
			for(const v of response.results.organizationMembership) {
				const k = "m-" + this.state.keyTracer
				this.state.itemObj[k] = <ListItem organization={v} view={this.props.view} key={k} id={k} site={this.props.site} />
				this.state.keyTracer++
			}
			Object.keys(this.state.itemObj).forEach((k => {
				added.push(this.state.itemObj[k])
			}))
			this.setState({listItems: added})
			if(this.props.view === "view-details") {
				this.setAllFieldsDisabled(true)
			}
			else {
				this.setAllFieldsDisabled(false)
			}
		})
	}

	componentWillMount() {
		selectedOrgs = {}
		if(this.props.farmerID != null) {
			this.getFarmerInfo()
			return
		}
		const category = APIFarmerRequest.getAllARBOCategories(this.state.accessToken)
		category.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.category_id, name: v.name})
			}
			const listItems = []
			const k = "m-" + this.state.keyTracer
			this.state.itemObj[k] = <ListItem categories={c} handler={this.eventHandler} key={k} id={k} site={this.props.site} />
			this.state.keyTracer++
			listItems.push(this.state.itemObj[k])
			this.setState({categories: c, listItems: listItems})
		})
	}

	getAllARBOCategories(orgMembership) {
		const category = APIFarmerRequest.getAllARBOCategories(this.state.accessToken)
		category.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.category_id, name: v.name})
			}
			const listItems = []
			for(const v of orgMembership) {
				const k = "m-" + this.state.keyTracer
				this.state.itemObj[k] = <ListItem categories={c} organization={v}
					view={this.props.view} handler={this.eventHandler} key={k} id={k} site={this.props.site} />
				this.state.keyTracer++
			}
			const k = "m-" + this.state.keyTracer
			this.state.itemObj[k] = <ListItem categories={c} selectedOrgs={this.state.selectedOrgs}
				handler={this.eventHandler} key={k} id={k} site={this.props.site} />
			this.state.keyTracer++
			Object.keys(this.state.itemObj).forEach((k => {
				listItems.push(this.state.itemObj[k])
			}))
			this.setState({listItems: listItems, categories: c})
			if(this.props.view === "view-details") {
				this.setAllFieldsDisabled(true)
			}
			else {
				this.setAllFieldsDisabled(false)
			}
		})
	}

	async eventHandler(e, compId, id, key) {
		switch(e) {
			case "org-selected":
				this.state.orgList[compId] = key
				this.props.onValueChange("org-membership", "organizationMembership", "membership", this.state.orgList)
				break
			case "add":
				if(key != null && this.props.view === "update") {
					this.state.upAddOrgList[compId] = key
					this.props.onValueChange("org-membership", "organizationMembership", "add", this.state.upAddOrgList)
				}
				const added = []
				const k = "m-" + this.state.keyTracer
				this.state.itemObj[k] = <ListItem
					categories={this.state.categories}
					selectedOrgs={this.state.selectedOrgs}
					handler={this.eventHandler} key={k} id={k}
					site={this.props.site} />
				this.state.keyTracer++
				Object.keys(this.state.itemObj).forEach((k => {
					added.push(this.state.itemObj[k])
				}))
				this.setState({listItems: added})
				break
			case "delete":
				if(key != null && this.props.view === "update") {
					this.state.deleteOrgList[compId] = key
					this.props.onValueChange("org-membership", "organizationMembership", "delete", this.state.deleteOrgList)
					delete this.state.upAddOrgList[compId]
					this.props.onValueChange("org-membership", "organizationMembership", "add", this.state.upAddOrgList)
				}
				if(this.state.listItems.length === 1) {
					break
				}
				delete this.state.itemObj[compId]
				delete this.state.orgList[compId]
				this.props.onValueChange("org-membership", "organizationMembership", "membership", this.state.orgList)
				const deleted = []
				Object.keys(this.state.itemObj).forEach((k => {
					deleted.push(this.state.itemObj[k])
				}))
				const so = this.state.selectedOrgs
				await this.setState({listItems: deleted})
				this.setState({selectedOrgs: so})
				break
			case "add-org":
				this.state.addOrgList[compId] = key
				this.props.onValueChange("add-org", "addToLibrary", "add-org", this.state.addOrgList)
				break
		}
	}

	render() {
		const view = <div className="membership">
			<div className="membership-row">
				<div className="col1"></div>
				<div className="col2">Partnership Type</div>
				<div className="col3">Organization Name</div>
			</div>
			{this.state.listItems}
		</div>
		return(view)
	}
}

let selectedOrgs = {}

class ListItem extends Component
{
	constructor(props) {
		super(props)
		const catOptions = []
		if(props.categories != null) {
			for(const v of props.categories) {
				catOptions.push(v)
			}
			catOptions.push({id: 0, name: "ADD NEW ORGANIZATION"})
		}
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			itemId: props.id,
			handler: props.handler,
			crops: props.crops,
			categories: props.categories,
			categoryOptions: catOptions,
			provincePlaceholder: "PROVINCE",
			cityPlaceholder: "CITY/MUNICIPALITY",
			arboName: "-- SELECT --",
			category: "-- SELECT --",
			membership: {},
			addedArboLib: {},
		}
		this.onAddItemClick = this.onAddItemClick.bind(this)
		this.onDeleteItem = this.onDeleteItem.bind(this)
		this.getAllOrganizationsBySiteId = this.getAllOrganizationsBySiteId.bind(this)
	}

	componentWillMount() {
		console.log('selectedOrgs -->', selectedOrgs)
		if(this.props.organization != null) {
			const orgs = APIOrganizationRequest.getOrganizationById(this.state.accessToken, this.props.organization.arbo_id)
			orgs.then((rc) => {
				const category = APIOrganizationRequest.getCategoryById(this.state.accessToken, this.props.organization.category_id)
				category.then((rc) => {
					this.setState({category: rc.results.name})
				})
				this.setState({arboName: rc.results.organization.name.toUpperCase()})
			})
			if(this.props.view === "view-details") {
				return
			}
		}
		this.getAllOrganizationsBySiteId(this.props.organization?.category_id)
		const sites = APISiteRequest.getAllSites(this.state.accessToken)
		sites.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.site_id, name: v.name.toUpperCase()})
			}
			this.setState({site: c})
		})
	}

	getAllOrganizationsBySiteId(id) {
		const orgs = APIOrganizationRequest.getAllOrganizationsBySiteId(this.state.accessToken, this.props.site)
		orgs.then((response) => {
			console.log('getAllOrganizationsBySiteId', response)
			if(response.status === "FAILED") {
				return
			}
			const c = []
			const partnerARBO = []
			const otherOrg = []
			for(const v of response.results.rows) {
				if(v.category_id === 1) {
					partnerARBO.push({id: v.arbo_id, name: v.name.toUpperCase()})
				}
				else {
					otherOrg.push({id: v.arbo_id, name: v.name.toUpperCase()})
				}
			}
			const orgs = []
			if(id) {
				if(id === 1) {
					for(const v of partnerARBO) {
						if(Object.values(selectedOrgs).includes(""+v.id)) {
							continue
						}
						orgs.push(v)
					}
				}
				else if(id === 2) {
					for(const v of otherOrg) {
						if(Object.values(selectedOrgs).includes(""+v.id)) {
							continue
						}
						orgs.push(v)
					}
				}
			}
			this.setState({partnerARBO: partnerARBO, otherOrg: otherOrg, organizations: orgs})
		})
	}

	componentDidMount() {
		if(this.props.organization != null) {
			this.state.membership["id"] = this.props.organization.id
			this.state.addedArboLib["id"] = this.props.organization.id
			this.setState({addDeleteButton: (this.props.view === 'update')? <img src={deleteIcon} className="delete-icn" alt="DELETE" onClick={this.onDeleteItem}/>:<img src={deleteIconGray} className="delete-icn" alt="DELETE"/>})
		}
		else {
			this.setState({addDeleteButton: <img src={addIcon} className="add-icon" alt="ADD" onClick={this.onAddItemClick} />})
		}
	}

	onAddItemClick() {
		this.state.handler("add", this.state.itemId, null, this.state.membership)
		this.setState({addDeleteButton: <img src={deleteIcon} className="delete-icon" alt="DELETE" onClick={this.onDeleteItem} />})
	}

	onDeleteItem() {
		this.setState({
			showConfirmMessage: true,
			aMessage: `Are you sure you want to remove organization member ${this.state.arboName}?`
		})
	}

	render() {
		const view = <div className="membership-row">
			<div className="col1">{this.state.addDeleteButton}</div>
			<div className="col2"><DropdownWidget onItemSelected={(id, val) => {
				if(id === "1") {
					const orgs = []
					for(const v of this.state.partnerARBO) {
						if(Object.values(selectedOrgs).includes(""+v.id)) {
							continue
						}
						orgs.push(v)
					}
					this.setState({addOrg: id, organizations: orgs})
				}
				else if(id === "2") {
					const orgs = []
					for(const v of this.state.otherOrg) {
						if(Object.values(selectedOrgs).includes(""+v.id)) {
							continue
						}
						orgs.push(v)
					}
					this.setState({addOrg: id, organizations: orgs})
				}
				else if(id === "0") {
					const region = APIGenericRequest.getAllRegions(this.state.accessToken)
					region.then((response) => {
						if(response.status === "FAILED") {
							return
						}
						const c = []
						for(const v of response.results.rows) {
							c.push({id: v.region_id, name: v.name})
						}
						this.setState({regions: c, addOrg: id})
					})
				}
				if(this.state.addDeleteButton.props.alt === "ADD") {
					this.onAddItemClick()
				}
			}} list={this.state.categoryOptions} placeholder={this.state.category} cStyle={{"width": "100%"}} /></div>
			{this.state.addOrg != 0 && <div className="col3" onMouseEnter={(e) => {
				//if AddOrg
					let updateOrgs = true
					Object.keys(selectedOrgs).forEach((k => {
						if(this.state.itemId === k) {
							updateOrgs = false
							return
						}
					}))
					if(!updateOrgs) {
						return
					}
					if(this.state.addOrg == 1) {
						const orgs = []
						for(const v of this.state.partnerARBO) {
							if(Object.values(selectedOrgs).includes(""+v.id)) {
								continue
							}
							orgs.push(v)
						}
						this.setState({organizations: orgs})
					}
					else if(this.state.addOrg == 2) {
						const orgs = []
						for(const v of this.state.otherOrg) {
							if(Object.values(selectedOrgs).includes(""+v.id)) {
								continue
							}
							orgs.push(v)
						}
						this.setState({organizations: orgs})
					}
				}}>
				<DropdownWidget list={this.state.organizations} placeholder={this.state.arboName} cStyle={{"width": "100%"}}
					onItemSelected={(id, val) => {
						//orgs included in a category dropdown
						selectedOrgs[this.state.itemId] = id
						this.state.membership["arbo_id"] = id
						this.state.handler("org-selected", this.state.itemId, null, this.state.membership)
						if(this.state.addDeleteButton.props.alt == "ADD") {
							this.onAddItemClick()
						}
					}}
				/>
			</div>}
			{this.state.addOrg == 0 && <div className="col3-add-org">
				<input type="text" onChange={(e) => {
						this.state.addedArboLib["name"] = e.target.value
						this.state.handler("add-org", this.state.itemId, null, this.state.addedArboLib)
				}} />
				<div className="ao-category">
					<DropdownWidget disabled={true} onItemSelected={(id, val) => {
						this.state.addedArboLib["category_id"] = id
						this.state.handler("add-org", this.state.itemId, null, this.state.addedArboLib)
						this.setState({categoryId: id})
					}} list={this.state.categories} placeholder="OTHER FARMER ORGANIZATION" cStyle={{"width": "100%"}} />
				</div>
				{/* <div className="ao-site">
				<DropdownWidget onItemSelected={(id, val) => {
					this.state.addedArboLib["site_id"] = id
					this.state.addedArboLib["category_id"] = 2
					this.state.handler("add-org", this.state.itemId, null, this.state.addedArboLib)
					this.setState({siteId: id})
				}} list={this.state.site} placeholder="SITE" cStyle={{"width": "100%"}} />
				</div> */}
				<div className="ao-region">
				<DropdownWidget list={this.state.regions} placeholder="REGION" cStyle={{"width": "100%"}} onItemSelected={(id, val) => {
					this.state.addedArboLib["region_id"] = id
					this.state.handler("add-org", this.state.itemId, null, this.state.addedArboLib)
					const province = APIGenericRequest.getAllProvincesByRegionId(this.state.accessToken, id)
					province.then((response) => {
						if(response.status === "FAILED") {
							return
						}
						const c = []
						for(const v of response.results.rows) {
							c.push({id: v.province_id, name: v.name})
						}
						this.setState({provinces: c, provincePlaceholder: "PROVINCE"})
					})
				}} />
				</div>
				<div className="ao-province">
				<DropdownWidget list={this.state.provinces} placeholder={this.state.provincePlaceholder} cStyle={{"width": "100%"}}  onItemSelected={(id, val) => {
					this.state.addedArboLib["province_id"] = id
					this.state.handler("add-org", this.state.itemId, null, this.state.addedArboLib)
					const province = APIGenericRequest.getAllCitiesByProvinceId(this.state.accessToken, id)
					province.then((response) => {
						if(response.status === "FAILED") {
							return
						}
						const c = []
						for(const v of response.results.rows) {
							c.push({id: v.city_id, name: v.name})
						}
						this.setState({cities: c, cityPlaceholder: "CITY/MUNICIPALITY"})
					})
				}} />
				</div>
				<div className="ao-city">
				<DropdownWidget list={this.state.cities} placeholder={this.state.cityPlaceholder} cStyle={{"width": "100%"}} onItemSelected={(id, val) => {
					this.state.addedArboLib["city_id"] = id
					this.state.handler("add-org", this.state.itemId, null, this.state.addedArboLib)
					const province = APIGenericRequest.getAllBarangaysByCityId(this.state.accessToken, id)
					province.then((response) => {
						if(response.status === "FAILED") {
							return
						}
						const c = []
						for(const v of response.results.rows) {
							c.push({id: v.city_id, name: v.name})
						}
						this.setState({barangays: c, brgyPlaceholder: "BARANGAY"})
					})
				}} />
				</div>
			</div>}
			{this.state.showConfirmMessage == true && <AlertMessage type="confirmation" text={this.state.aMessage}
			onClick={(e) => {
				this.setState({showConfirmMessage: false})
				if(e.target.innerHTML === "NO") {
				}
				else {
					delete selectedOrgs[this.state.itemId]
					this.state.handler("delete", this.state.itemId, null, this.state.membership)
				}
			}} />}
		</div>
		return(view)
	}
}

export default Membership
